import { render } from "./ModalChangeLog.vue?vue&type=template&id=3afe24ce&scoped=true"
import script from "./ModalChangeLog.vue?vue&type=script&lang=js"
export * from "./ModalChangeLog.vue?vue&type=script&lang=js"

import "./ModalChangeLog.vue?vue&type=style&index=0&id=3afe24ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afe24ce"]])

export default __exports__